import React from 'react';
import './NavContent.css';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { List, ListItem } from '@simplybusiness/mobius';
import { getUser } from 'resources/user/selectors';
import { trackStructEvent } from '../../services/TrackingService';
import { signOut as signOutFromServer } from '../../services/AuthenticationService';
import {
  appLinks, NavLink, usPageLinks, ukPageLinks, resolveTrackingLabel,
} from './navLinks';
import NavButton from './NavButton';
import configurationService from '../../services/ConfigurationService';

type NavContentProps = {
  onNavigate?: () => void;
};

const NavContent = ({ onNavigate }: NavContentProps) => {
  const navigate = useNavigate();
  const currentPath = window.location.pathname;
  const pageLinks = configurationService.onlyUSTraffic() ? usPageLinks : ukPageLinks;
  const user = useSelector(getUser);

  const logout = async () => {
    await signOutFromServer();
    navigate('/sign-in');
    onNavigate?.();
  };

  const handleNavButtonClick = (link: NavLink): void => {
    trackStructEvent({
      category: 'customer_account_menu_navigation',
      label: link.label.toLowerCase(),
      action: `menu_link_clicked_${resolveTrackingLabel(link)}`,
      property: user?.customerAccountId || 'no_customer_account_retrieved',
    });

    if (link.href === 'logout') {
      logout();

      return;
    }

    if (link.urlDestination === 'internal') {
      navigate(link.href);
      onNavigate?.();
    } else {
      window.open(link.href, '_blank');
      onNavigate?.();
    }
  };

  const renderLinks = (links: NavLink[]) => (
    <List className="nav-content__list">
      {links.map(link => (
        <ListItem key={link.label} className="nav-content__item">
          <NavButton
            label={link.label}
            href={link.href}
            icon={link.icon}
            isActive={currentPath === link.href}
            onClick={() => handleNavButtonClick(link)}
            testId={link.label}
          />
        </ListItem>
      ))}
    </List>
  );

  return (
    <div className="nav-content" data-testid="nav-content">
      {renderLinks(pageLinks)}

      <div className="divider" />

      {renderLinks(appLinks)}
    </div>
  );
};

export default NavContent;
